import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class EmployeeService {
    private baseApiUrl: string;
  private documentPreviewUrl: string;
    constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
         this.documentPreviewUrl = `${configurationService.BasePreviewUrl}employeedocument/`;
    }

    getFiltered(filter: string, pageIndex: number, pageSize: number,
        sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

        const params = {
            filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
        };
    
        return this.httpClient.post(this.baseApiUrl + 'employeedetails/filter', params).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getAll(forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `employeedetails?isMaintenance=${forMaintenance}`).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

      GetLoanOfficers(forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `employeedetails/getLoanOfficers?isMaintenance=${forMaintenance}`).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }


    getCountryCode(forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `employeedetails/getAllCountryCode?isMaintenance=${forMaintenance}`).pipe(
            map((res: any) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getById(id: number, forMaintenance: boolean = false): Observable<any> {
        return this.httpClient.get(this.baseApiUrl + `employeedetails/${id}?isMaintenance=${forMaintenance}`).pipe(
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    create(currency: any): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + `employeedetails`, currency).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

      getDocumentContentAsDataUrl(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(`${this.documentPreviewUrl}${id}?isMaintenance=${forMaintenance}`, { responseType: 'text' }).pipe(
      map(res => ({ id, dataUrl: res })),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

    update(currency: any): Observable<any> {
        return this.httpClient.put(this.baseApiUrl + `employeedetails`, currency).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    authorise(id: number): Observable<any> {
        return this.httpClient.post(this.baseApiUrl + `employeedetails/authorise`, id).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    delete(id: number): Observable<any> {
        return this.httpClient.delete(this.baseApiUrl + `employeedetails/${id}`).pipe(
            map((res: Response) => res),
            catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

   

}
